module.exports = __webpack_public_path__ + "static/media/tandybasicbook.990470f2.jpg";